import { FeatureKey, PlanTier } from '../../types/enums'

/**
 * Unlimited. Deliberately `null` rather than -1 or Infinity: it round-trips through JSON
 * unchanged and forces every consumer to handle the case explicitly instead of silently
 * comparing against a magic number.
 */
export const UNLIMITED = null

export type LimitValue = number | boolean | null

/** The pricing table, verbatim. The single source of truth for what a tier includes. */
export const PLAN_MATRIX: Record<PlanTier, Record<FeatureKey, LimitValue>> = {
  [PlanTier.Start]: {
    [FeatureKey.Customers]: 150,
    [FeatureKey.ReservationsPerMonth]: 50,
    [FeatureKey.Employees]: 1,
    [FeatureKey.Places]: 2,
    [FeatureKey.Activities]: 5,
    [FeatureKey.EventBlueprints]: 3,
    [FeatureKey.Announcements]: false,
    [FeatureKey.DataExport]: false,
    [FeatureKey.WebElements]: false,
    [FeatureKey.SmsNotifications]: false,
  },
  [PlanTier.Growth]: {
    [FeatureKey.Customers]: 2000,
    [FeatureKey.ReservationsPerMonth]: 500,
    [FeatureKey.Employees]: 3,
    [FeatureKey.Places]: 10,
    [FeatureKey.Activities]: 20,
    [FeatureKey.EventBlueprints]: UNLIMITED,
    [FeatureKey.Announcements]: true,
    [FeatureKey.DataExport]: true,
    [FeatureKey.WebElements]: true,
    [FeatureKey.SmsNotifications]: true,
  },
  [PlanTier.Pro]: {
    [FeatureKey.Customers]: UNLIMITED,
    [FeatureKey.ReservationsPerMonth]: UNLIMITED,
    [FeatureKey.Employees]: 10,
    [FeatureKey.Places]: UNLIMITED,
    [FeatureKey.Activities]: UNLIMITED,
    [FeatureKey.EventBlueprints]: UNLIMITED,
    [FeatureKey.Announcements]: true,
    [FeatureKey.DataExport]: true,
    [FeatureKey.WebElements]: true,
    [FeatureKey.SmsNotifications]: true,
  },
  [PlanTier.Custom]: {
    [FeatureKey.Customers]: UNLIMITED,
    [FeatureKey.ReservationsPerMonth]: UNLIMITED,
    [FeatureKey.Employees]: UNLIMITED,
    [FeatureKey.Places]: UNLIMITED,
    [FeatureKey.Activities]: UNLIMITED,
    [FeatureKey.EventBlueprints]: UNLIMITED,
    [FeatureKey.Announcements]: true,
    [FeatureKey.DataExport]: true,
    [FeatureKey.WebElements]: true,
    [FeatureKey.SmsNotifications]: true,
  },
}
